var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{on:{"click":function($event){return _vm.annuler()}}},[_vm._v("Annuler")]),_c('br'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }